import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import CardSkeleton from "./CardSkeleton";

const NewYorkSkeleton = () => {
  return (
    <Stack spacing={2} py={2}>
      {/* Cards */}
      <Stack sx={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:2}}>
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </Stack>

      {/* Age Distribution */}
      <Skeleton variant="rounded" width="100%" height={300} />

      {/* Communication Activity */}
      <Skeleton variant="rounded" width="100%" height={350} />

      {/* Financial Metrics */}
      <Skeleton variant="rounded" width="100%" height={250} />

      {/* Revenue Chart */}
      <Skeleton variant="rounded" width="100%" height={350} />

      {/* Activity Matrix */}
      <Skeleton variant="rounded" width="100%" height={300} />

      {/* SignUp Distribution */}
      <Skeleton variant="rounded" width="100%" height={300} />

       
    </Stack>
  );
};

export default NewYorkSkeleton;
